import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultViewRedirectFlagTitle: {
		id: 'business-horizontal-nav.project-navigation.default-view-redirect-flag-title',
		defaultMessage: "We've taken you to the default view",
		description:
			'Error message title informing the user that they were redirected to the default view.',
	},
	defaultViewRedirectFlagDescription: {
		id: 'business-horizontal-nav.project-navigation.default-view-redirect-flag-description',
		defaultMessage: "The view you're trying to access has been removed.",
		description:
			'Error message description informing the user that the view they are trying to access has been removed.',
	},
	defaultErrorMessage: {
		id: 'business-horizontal-nav.project-navigation.default-error-message',
		defaultMessage: 'Try refreshing or navigating to another page.',
		description: 'Error message informing the user that querying the navigation items has failed.',
	},
	defaultErrorTitle: {
		id: 'business-horizontal-nav.project-navigation.default-error-title',
		defaultMessage: "Something's gone wrong",
		description: 'Error title when querying the navigation items fails',
	},
	unauthenticatedUserErrorTitle: {
		id: 'business-horizontal-nav.project-navigation.unauthenticated-user-error-title',
		defaultMessage: "You'll need to log in",
		description: 'Error title when the request fails due to the user not being logged in.',
	},
	unauthenticatedUserErrorMessage: {
		id: 'business-horizontal-nav.project-navigation.unauthenticated-user-error-message',
		defaultMessage:
			'You need to be logged in to manage the navigation. Please log in and try again.',
		description: 'Error message when the request fails due to the user not being logged in.',
	},
	unauthorizedUserErrorTitle: {
		id: 'business-horizontal-nav.project-navigation.unauthorized-user-error-title',
		defaultMessage: "You don't have permission",
		description: 'Error flag title when the request fails due to the user not being authorized.',
	},
	unauthorizedUserErrorMessage: {
		id: 'business-horizontal-nav.project-navigation.unauthorized-user-error-message',
		defaultMessage: "You don't have permission to view this project.",
		description: 'Error flag message when the request fails due to the user not being authorized.',
	},
	projectNotFoundErrorTitle: {
		id: 'business-horizontal-nav.project-navigation.project-not-found-error-title',
		defaultMessage: 'Project not found',
		description: 'Error flag title when the request fails because the project was not found.',
	},
	projectNotFoundErrorMessage: {
		id: 'business-horizontal-nav.project-navigation.project-not-found-error-message',
		defaultMessage: "The project might have been deleted or you don't have permission.",
		description: 'Error flag message when the request fails because the project was not found.',
	},
});
